import React, { FC, Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import { NAV_ROUTES } from '../constants/navRoutes';
import { FullPageLoader } from '@components';

// Lazy load all page components
const UserListPage = React.lazy(() =>
  import('../pages').then((module) => ({ default: module.UserManagementPage })),
);
const DashboardPage = React.lazy(() =>
  import('../pages').then((module) => ({ default: module.DashboardPage })),
);
const DashboardRequest = React.lazy(
  () => import('../pages/Admin/SelfServeRequests/DashboardRequests'),
);
const FeedbackDashboard = React.lazy(
  () => import('../pages/Dashboard/CustomDashboards/FeedbackDashboard'),
);

const NotificationsDashboard = React.lazy(
  () => import('../pages/Dashboard/CustomDashboards/NotificationsDashboard'),
);
const DealSetup = React.lazy(() => import('../pages/Admin/DealSetup/DealSetup'));

const PrivateRoutes: FC = () => (
  <Suspense fallback={<FullPageLoader hasSideNav={true} />}>
    <Routes>
      <Route path={NAV_ROUTES.FEEDBACK} element={<FeedbackDashboard />} />
      <Route path={NAV_ROUTES.NOTIFICATIONS} element={<NotificationsDashboard />} />
      <Route path={NAV_ROUTES.USER_MANAGEMENT} element={<UserListPage />} />
      <Route path={NAV_ROUTES.DASHBOARD_REQUESTS} element={<DashboardRequest />} />
      <Route path={NAV_ROUTES.DEALS} element={<DealSetup />} />
      <Route path={NAV_ROUTES.DASHBOARD} element={<DashboardPage />} />
      <Route path={NAV_ROUTES.DASHBOARD_MODULE} element={<DashboardPage />} />
      <Route path={NAV_ROUTES.DASHBOARD_MODULE_SUBMODULE} element={<DashboardPage />} />
      <Route path={NAV_ROUTES.DASHBOARD_MODULE_SUBMODULE_ID} element={<DashboardPage />} />
      <Route path="*" element={<Navigate to={NAV_ROUTES.PAGE_NOT_FOUND} />} />
    </Routes>
  </Suspense>
);

export default PrivateRoutes;
